import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Grid,
  GridItem,
  Stack,
} from "@chakra-ui/react";

function ReservationTime() {
  return (
    <TableContainer className="tableContainer">
      <Table variant='striped' colorScheme='teal'>
        <Thead>
          <Tr id="tableHead">
            <Th id="listNum" className="table-headCol">ردیف</Th>
            <Th className="table-headCol">موضوع</Th>
            <Th className="table-headCol">تاریخ</Th>
            <Th className="table-headCol">ساعت</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td id="listNum" className="table-bodyCol">1</Td>
            <Td className="table-bodyCol">نقل و انتقال</Td>
            <Td className="table-bodyCol">1402/2/5</Td>
            <Td className="table-bodyCol">13:00 - 13:20</Td>  
          </Tr>
          <Tr>
            <Td id="listNum" className="table-bodyCol">2</Td>
            <Td className="table-bodyCol">درخواست وام</Td>
            <Td className="table-bodyCol">1402/3/8</Td>
            <Td className="table-bodyCol">8:30 - 9:00</Td>
          </Tr>
          <Tr>
            <Td id="listNum" className="table-bodyCol">3</Td>
            <Td className="table-bodyCol">سایر</Td>
            <Td className="table-bodyCol">1402/3/14</Td>
            <Td className="table-bodyCol">9:30 - 10:00</Td>
          </Tr>
          <Tr>
            <Td id="listNum" className="table-bodyCol">4</Td>
            <Td className="table-bodyCol">نقل و انتقال</Td>
            <Td className="table-bodyCol">1402/4/02</Td>
            <Td className="table-bodyCol">14:30 - 15:00</Td>
          </Tr>
          <Tr>
            <Td id="listNum" className="table-bodyCol">5</Td>
            <Td className="table-bodyCol">سایر</Td>
            <Td className="table-bodyCol">1402/4/17</Td>
            <Td className="table-bodyCol">10:30 - 11:00</Td>
          </Tr>
          <Tr>
            <Td id="listNum" className="table-bodyCol">6</Td>
            <Td className="table-bodyCol">شکایت</Td>
            <Td className="table-bodyCol">1402/5/10</Td>
            <Td className="table-bodyCol">9:30 - 10:00</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
}

export default ReservationTime;
